import { apiSlice } from '../apiSlice';
import {
	DialogPageFilter,
	PopupMessageDTO,
} from '../DTO/app-setting/dialog.interface';
import { SuccessResponse, Paginated } from '../DTO/common.interface';

export const dialogApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getDialogList: builder.query<
			SuccessResponse<Paginated<PopupMessageDTO>>,
			DialogPageFilter
		>({
			query: (body) => ({
				url: `/web/popup-message/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['DialogList'],
		}),
		getDialogSortList: builder.query<SuccessResponse<PopupMessageDTO[]>, null>({
			query: () => ({
				url: `/web/popup-message/list`,
				method: 'GET',
			}),
		}),
		sortDialogList: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/popup-message/sort`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['DialogList'],
		}),
		getDialogDetail: builder.query<SuccessResponse<PopupMessageDTO>, string>({
			query: (id) => ({
				url: `/web/popup-message/${id}`,
				method: 'GET',
			}),
			providesTags: ['DialogDetail'],
		}),
		deleteDialogList: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/popup-message/${id}`,
				method: 'DELETE',
			}),
		}),
		createDialog: builder.mutation<SuccessResponse<any>, PopupMessageDTO>({
			query: (body) => ({
				url: `/web/popup-message`,
				method: 'POST',
				body,
			}),
		}),
		updateDialog: builder.mutation<SuccessResponse<any>, PopupMessageDTO>({
			query: (body) => ({
				url: `/web/popup-message/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['DialogDetail'],
		}),
	}),
});

export const {
	useGetDialogListQuery,
	useGetDialogSortListQuery,
	useSortDialogListMutation,
	useGetDialogDetailQuery,
	useDeleteDialogListMutation,
	useCreateDialogMutation,
	useUpdateDialogMutation,
} = dialogApiSlice;
